import { render } from "./ElementPanel.vue?vue&type=template&id=52e0e48a"
import script from "./ElementPanel.vue?vue&type=script&lang=js"
export * from "./ElementPanel.vue?vue&type=script&lang=js"

import "./ElementPanel.vue?vue&type=style&index=0&id=52e0e48a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__